import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PageContainer = styled.div `
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  background-color: color-mix(in srgb, ${theme.semantic.surface.sunken}, transparent 50%);
`;
